
import React from "react";
import { Button } from "@/components/ui/button";
import { Loader2, Send } from "lucide-react";

interface FormActionsProps {
  isPending: boolean;
  isFormComplete: boolean;
  isMobile: boolean;
  onCancel: () => void;
}

const FormActions = ({ 
  isPending, 
  isFormComplete, 
  isMobile, 
  onCancel 
}: FormActionsProps) => {
  return (
    <div className="flex justify-end space-x-2 pt-4">
      <Button 
        type="button" 
        variant="outline" 
        onClick={onCancel}
        style={isMobile ? {
          position: 'static',
          transform: 'none',
          touchAction: 'auto',
          pointerEvents: 'auto'
        } : undefined}
      >
        Annuleren
      </Button>
      <Button 
        type="submit" 
        disabled={isPending || !isFormComplete}
        variant={isFormComplete ? "default" : "outline"}
        className={isFormComplete ? "" : "text-muted-foreground bg-gray-100 hover:bg-gray-100"}
        style={isMobile ? {
          position: 'static',
          transform: 'none',
          touchAction: 'auto',
          pointerEvents: 'auto'
        } : undefined}
      >
        {isPending ? (
          <>
            <Loader2 className="mr-2 h-4 w-4 animate-spin" />
            Bezig...
          </>
        ) : (
          <>
            <Send className="mr-2 h-4 w-4" />
            Verzenden
          </>
        )}
      </Button>
    </div>
  );
};

export default FormActions;
